import { render, staticRenderFns } from "./MenusList.vue?vue&type=template&id=6911a6e2"
import script from "./MenusList.vue?vue&type=script&lang=js"
export * from "./MenusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports